import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const get = (query) => axios.get(toQueryString("api/v1/content-overview?", query));

const ApiContentOverview = {
  get
};

export default ApiContentOverview;
